import { useEffect, useState } from "react"
import NotificationsService from "../../../../../services/web/notification-service";

const useNotificationSSE = () => {
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const eventSource = NotificationsService.subscribe({
            onMessage: (event) => {
                const parsedData = JSON.parse(event.data);

                if (Array.isArray(parsedData) && parsedData.length > 0) {
                    setNotifications((prev) => {
                        return parsedData.reduce((acc, item) => {
                            if (item.remove) return acc.filter((old) => old.id !== item.id);

                            if (!acc.some((old) => old.id === item.id)) acc.push(item);
                            else {
                                const found = acc.find((old) => old.id === item.id);
                                if (found) found.relationship = item.relationship;
                            };

                            return acc;
                        }, [...prev]);
                    });
                };
            },
            onError: (e) => {
                console.error("Error to load events.");
                console.error(e);
            },
        });

        return () => eventSource.close();
    }, []);

    return { notifications };
};

export default useNotificationSSE;